import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-match-order-match-list',
  templateUrl: './preview-match-order-match-list.component.html',
  styleUrls: ['./preview-match-order-match-list.component.scss']
})
export class PreviewMatchOrderMatchListComponent {
  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  responseData: any[] = [];
  constructor(public sanitizer: DomSanitizer) { }

}
